import { env } from '@lib/env'

export const emptyValues = new Set([undefined, null, ''])

export function getId<T extends { id?: string; _id?: string }>(obj: T): string {
  return obj.id ?? (obj._id as string)
}

export function getIframeUrl(path: string, id: string, options?: { theme?: string | null }) {
  const url = new URL(`${env.domain}${path}`)
  url.searchParams.set('iframe', id)
  if (options?.theme) url.searchParams.set('theme', options.theme)

  return url.href
}

export function nanoid(): string {
  return Math.random().toString(36).substring(2)
}

export function stripPhoneNumber(val: string | null | undefined) {
  if (!val) return ''

  return val.replace(/\D/gi, '')
}

export function formatPhoneNumber(val: string | null | undefined) {
  if (!val) return ''

  const phoneParts: string[] = []
  const rawValue = stripPhoneNumber(val)

  if (rawValue.length > 0) phoneParts.push('(')
  phoneParts.push(rawValue.slice(0, 3))

  if (rawValue.length > 3) phoneParts.push(') ')
  phoneParts.push(rawValue.slice(3, 6))

  if (rawValue.length > 6) phoneParts.push('-')
  phoneParts.push(rawValue.slice(6))

  return phoneParts.join('')
}

export function countryCodeSafePhone(val: string | null | undefined) {
  if (!val) return ''

  return val.length === 10 ? `1${val}` : val
}

export function formatPercent(val: number | null | undefined) {
  if (!val) return '0%'

  const formatter = new Intl.NumberFormat(undefined, { style: 'percent', maximumFractionDigits: 2 })
  return formatter.format(val)
}

export function formatPrice(val: number | null | undefined, options?: Intl.NumberFormatOptions) {
  if (val === null || val === undefined) return null
  else {
    const isWholeNumber = val % 1 === 0
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
      ...(options ?? {}),
      maximumFractionDigits: isWholeNumber ? 0 : 2,
      minimumFractionDigits: isWholeNumber ? 0 : 2,
    })

    return formatter.format(val)
  }
}

export const nthNumber = (number: number) => {
  if (number > 3 && number < 21) return 'th'
  switch (number % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}
